import { Expose } from '@nts/std';
import { WidgetBaseValueDto } from './widget-base-value-dto';

export class WidgetNumericValue extends WidgetBaseValueDto {

    @Expose()
    currentValue: number;
}
